/** Presentation only. Never use this loading hint as authentication state. */
export function restorePublicShell() {
  document.documentElement.classList.remove("session-shell-pending");
  const shell = document.getElementById("app-shell");
  if (shell) shell.style.pointerEvents = "";
}

/** Wait for route content, including routes whose lazy chunk takes several seconds. */
export function handoffAppShell() {
  let scheduled = false;
  const observer = new MutationObserver(checkReady);
  const timeout = window.setTimeout(restorePublicShell, 15000);

  function checkReady() {
    if (scheduled) return;
    const main = document.querySelector("#root main#main-content, #root [role='main']#main-content");
    if (!main?.querySelector("h1")) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      document.documentElement.classList.add("app-ready");
      document.documentElement.classList.remove("session-shell-pending");
      document.getElementById("app-shell")?.remove();
      // The worker can add static navigation outside #app-shell. Retire only
      // that initial HTML chrome; preserve the app's own accessible navigation.
      const root = document.getElementById("root");
      document.querySelectorAll(
        '#typelab-home-discovery, [data-typelab-shell-only], .typelab-static-header, .typelab-static-footer, .typelab-static-skip, body > a.skip-link',
      ).forEach((element) => {
        if (!root?.contains(element)) element.remove();
      });
      window.clearTimeout(timeout);
      observer.disconnect();
    });
  }

  observer.observe(document.body, { childList: true, subtree: true });
  checkReady();
  return () => {
    observer.disconnect();
    window.clearTimeout(timeout);
  };
}
